var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33337 2.66659L6.20004 1.58325C6.32671 1.42525 6.51804 1.33325 6.72071 1.33325H9.28004C9.48271 1.33325 9.67404 1.42525 9.80071 1.58325L10.6667 2.66659V2.66659V3.33325C10.6667 3.70125 10.368 3.99992 10 3.99992H6.00004C5.63204 3.99992 5.33337 3.70125 5.33337 3.33325V2.66659V2.66659H5.33337Z",
    stroke: "#167E42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33329 2.66675H3.99996C3.26329 2.66675 2.66663 3.26341 2.66663 4.00008V12.6667C2.66663 13.4034 3.26329 14.0001 3.99996 14.0001H12C12.7366 14.0001 13.3333 13.4034 13.3333 12.6667V4.00008C13.3333 3.26341 12.7366 2.66675 12 2.66675H10.6666",
    stroke: "#167E42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 7.33333H10.6667",
    stroke: "#167E42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 10.6666H10.6667",
    stroke: "#167E42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusNew);
export default __webpack_public_path__ + "static/media/status_new.fe6925c489e73556a2f73d7fa8028bba.svg";
export { ForwardRef as ReactComponent };